export interface iWebLoading { loading: boolean, text: string, success: boolean }
export const clientHelpers = {
	setStateLoading: (loading: boolean, text?: string, success?: boolean): iWebLoading => {
		return { loading, text: text || '', success: success || false }
	},
	generateColumns: (data: any, fieldHidden: string[] = []) => {
		const columns: {
			field: string
			header: string
			visible: boolean
		}[] = []
		for (const key in data) {
			if (Object.prototype.hasOwnProperty.call(data, key)) {
				const element = data[key]
				columns.push({
					field: key,
					header: key,
					visible: !fieldHidden.includes(key.toLowerCase())
				})
			}
		}
		return columns
	},
	getHeaders: (listItem: any[]) => { // heper function
		const headers: string[] = []
		if (listItem.length > 0) {
			Object.entries(listItem).map(([k, v]) => {
				/* console.log('getters crBaseHeadersPivot k:', k);
				console.log('getters crBaseHeadersPivot v:', v); */
				Object.keys(v).map((ObjectKey) => {
					/* funziona ma poi non fa il match con le colonne della tabella, VERIFICARE!!!! 21/06/2023
			 if (!headers.includes(`${ObjectKey} - ${clientHelpers.getTypeString(v[ObjectKey])}`)) {
			  headers.push(`${ObjectKey} - ${clientHelpers.getTypeString(v[ObjectKey])}`)
			} */
					if (!headers.includes(ObjectKey)) {
						headers.push(ObjectKey)
					}
				})
			})
		}
		return headers
	},
	// funzione per ottenere il tipo di dato di una interfaccia
	getTypeString: <T>(value: T) => {
		const typeOfPropertyInterface = Object.prototype.toString.call(value)
		return typeOfPropertyInterface.slice(8, -1)
	},

	getPropertyType: (objectWithProperty: any) => {
		const nameTypeFiled: string[] = []
		for (const [key, value] of Object.entries(objectWithProperty)) {
			if (value === null) {
				nameTypeFiled.push(`${key}: null`)
			} else if (Array.isArray(value)) {
				const elementType = value.length > 0 ? typeof value[0] : 'any'
				nameTypeFiled.push(`${key}: ${elementType}[]`)
			} else if (typeof value === 'string') {
				const dateRegex = /^\d{4}-\d{2}-\d{2}$/
				if (dateRegex.test(value) && new Date(value).toString() !== 'Invalid Date') {
					nameTypeFiled.push(`${key}: Date`)
				} else {
					nameTypeFiled.push(`${key}: ${typeof value}`)
				}
			} else {
				nameTypeFiled.push(`${key}: ${typeof value}`)
			}
		}
		return nameTypeFiled
	},
	dateToString: (dateTransform: Date | string | undefined, convert: boolean = true) => {
		// if undefined or null return empty string
		try {
			if (!dateTransform) { return '' }
			// dateTransform format is string 2019-05-08T12:32:25, remove T and convert to date
			if (typeof dateTransform === 'string' && convert) {
				if (dateTransform.includes('T')) {
					dateTransform = dateTransform.split('T')[0]
				}
				dateTransform = new Date(dateTransform)
			}
			const dateTime = typeof dateTransform === 'string' ? new Date(+dateTransform) : dateTransform // || new Date()
			// convert date format to dd-mm-yyyy
			const tStr = dateTime.toISOString().slice(0, 10)// .split('-').reverse().join('-')
			return convert ? tStr.split('-').reverse().join('-') : tStr
		} catch (error) {
			console.log('dateToString value input:', dateTransform, ' dateToString error:', error)
			return ''
		}
	}
}
